import makeStyles from '@material-ui/core/styles/makeStyles';
import { ERebrandingColors, ERebrandingFonts } from 'helpers/constants';

const styles = makeStyles((theme) => ({
  root: {
    padding: 2,
    borderRadius: 8,
    backgroundColor: '#f2f2f2',
    fontFamily: ERebrandingFonts.OPENSANS,
  },
  main: {
    padding: 8,
    borderRadius: 'inherit',
    backgroundColor: '#fff',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      '&:last-of-type': {
        justifyContent: 'space-between',
      },
    },
  },
  title: {
    fontSize: '14px !important',
    paddingRight: 6,
  },
  value: {
    fontSize: 17,
    fontWeight: 700,
    lineHeight: '100%',
  },
  colorDefault: { color: ERebrandingColors.MAIN },
  colorSuccess: { color: theme.palette.success.main },
  cta: {
    padding: '0 10px',
    height: 'unset',
    fontSize: 10,
    lineHeight: '23px',
    minWidth: 'unset',
  },
  extra: {
    padding: '7px 8px',
    fontSize: 11,
    color: theme.palette.grey[500],
    display: 'flex',
    alignItems: 'center',
    '& a': {
      display: 'inherit',
      alignItems: 'inherit',
      color: 'inherit',
    },
  },
  valueButtonWrapper: {
    flexWrap: 'wrap',
  },
}));

export default styles;
